import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';
import defaultBackground from './assets/images/bg.png';

import MessagesList from './components/MessagesList/MessagesList';
import { useState } from 'react';
import { useLayoutEffect } from 'react';
import { createImage } from './helpers/titreHelper';
import { useEffect } from 'react';
import { useVote } from './hooks/useVote';

function App() {
  const { voteState, currentState, voteActivity: isVisible } = useVote();
  const { showedMessages, winnerMessage, speed, winIds } =
    useCarousel(currentState);

  const {
    bg,
    authorFontSize,
    msgFontSize,
    phoneNumberFontSize,
    bgColor,
    msgDataField,
  } = useGetParams();

  const [prize, setPrize] = useState({ src: 'default' });

  useEffect(() => {
    let imgWrapper = document.getElementById('img-loader');
    if (imgWrapper && voteState) {
      voteState.vars.forEach((el) => {
        if (el.varImgUrl && el.varImgUrl !== '1') {
          imgWrapper.appendChild(createImage(el.varImgUrl));
        }
      });
    }
  }, [voteState?.vars?.length]);

  useLayoutEffect(() => {
    if (currentState === 'S5' || !currentState) {
      setPrize({
        src: 'default',
      });
      return;
    }

    let numberState = Number(currentState.slice(1));

    if (numberState > 5 && voteState) {
      let curVar = voteState.vars.find(
        (el) => Number(el.varnum) === numberState - 5,
      );
      if (
        curVar &&
        curVar.varImgUrl &&
        curVar.varImgUrl !== '1' &&
        prize.src !== curVar.varImgUrl
      ) {
        setPrize(() => ({
          src: curVar.varImgUrl,
        }));
      }
    }
  }, [currentState, voteState, prize.src]);

  return (
    <div
      className="app-wrapper"
      style={{
        background:
          bg && bg !== '0'
            ? `url(${
                bg === '1' ? defaultBackground : bg
              })center/cover no-repeat, ${bgColor}`
            : `none, ${bgColor}`,
        '--speed': `${speed || 0}ms`,
      }}
    >
      <CSSTransition
        in={isVisible}
        timeout={500}
        classNames="fade-scale"
        unmountOnExit
      >
        <div className="message-wrapper">
          <CSSTransition
            in={showedMessages && Boolean(currentState)}
            timeout={500}
            // classNames="fade-scale"
            unmountOnExit
          >
            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              authorFontSize={authorFontSize}
              msgFontSize={msgFontSize}
              phoneNumberFontSize={phoneNumberFontSize}
              currentState={currentState}
              speed={speed || 0}
              winIds={winIds}
              msgDataField={msgDataField}
            />
          </CSSTransition>
        </div>
      </CSSTransition>

      <SwitchTransition>
        <CSSTransition
          key={prize.src}
          addEndListener={(node, done) =>
            node.addEventListener('transitionend', done, false)
          }
          classNames="fade-scale"
        >
          <div className="prize">
            {Boolean(currentState) &&
              currentState !== 'S5' &&
              prize.src !== 'default' && <img src={prize.src} alt="" />}
          </div>
        </CSSTransition>
      </SwitchTransition>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
